/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const ArrowLeftLg: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="arrow-left-lg" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M1133.3333333333333 736.6666666666667H443.7L760.4666666666666 1053.4333333333334L680 1133.3333333333333L226.6666666666667 680L680 226.6666666666668L759.9 306.5666666666666L443.7 623.3333333333334H1133.3333333333333V736.6666666666667z" : "M906.6666666666669 589.3333333333333H354.9600000000001L608.3733333333333 842.7466666666667L544 906.6666666666666L181.3333333333334 544L544 181.3333333333333L607.9200000000001 245.2533333333334L354.9600000000001 498.6666666666666H906.6666666666669V589.3333333333333z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
ArrowLeftLg.displayName = `Blueprint5.Icon.ArrowLeftLg`;
export default ArrowLeftLg;
